module.exports = __webpack_public_path__ + "img/넙죽이-02.a8d7b8d5.png";